import { Injectable, Inject } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { tap, catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { DashboardKpis } from '../models/dashboard.model';
import { ApiError } from '@pharvio/core/shared';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { DASHBOARD_DATA_SERVICE } from '@pharvio/dashboard/data-access';
import { DashboardDataService } from '../data/dashboard-data.service';
import { LoadDashboardKpis } from './dashboard.actions';
import {
  AsyncDataItem,
  AsyncDataItemState,
  wrapAsAsyncDataItem,
  idleDataItem,
  isLoading,
  isError
} from '@pharvio/core/shared';

export interface DashboardStateModel {
  kpis: AsyncDataItem<DashboardKpis | null>;
}

@State<DashboardStateModel>({
  name: 'dashboard',
  defaults: { kpis: idleDataItem(null) }
})
@Injectable()
export class DashboardState {
  constructor(
    @Inject(DASHBOARD_DATA_SERVICE)
    private readonly dashboardService: DashboardDataService
  ) {}

  @Selector()
  static kpis(state: DashboardStateModel): AsyncDataItem<DashboardKpis | null> {
    return state.kpis;
  }

  @Selector()
  static loading(state: DashboardStateModel): boolean {
    return isLoading(state.kpis);
  }

  @Selector()
  static error(state: DashboardStateModel): ApiError | null {
    return isError(state.kpis) ? state.kpis.error : null;
  }

  @Action(LoadDashboardKpis)
  loadKpis(ctx: StateContext<DashboardStateModel>, action: LoadDashboardKpis) {
    ctx.patchState({
      kpis: wrapAsAsyncDataItem({ data: ctx.getState().kpis.data })
    });
    return this.dashboardService.getKpis(action.branchId).pipe(
      tap((kpis) =>
        ctx.patchState({
          kpis: wrapAsAsyncDataItem({
            data: kpis,
            state: AsyncDataItemState.LOADED
          })
        })
      ),
      catchError((error) => {
        ctx.patchState({
          kpis: wrapAsAsyncDataItem({
            data: ctx.getState().kpis.data,
            state: AsyncDataItemState.ERROR,
            error
          })
        });
        return EMPTY;
      })
    );
  }
}
